<script lang="ts">
  import { onMount } from 'svelte';
  import { PLANES, signup, verifyEmail, mensajeError, SignupError, type PlanSlug, type SignupResponse } from '../lib/signup';
  import { login } from '../lib/auth.svelte';
  const CK = 'toscana.signup.creds';
  let step = $state<'plan'|'datos'|'verificar'|'exito'>('plan');
  let plan = $state<PlanSlug>('hospital-pro');
  let nombre=$state(''),email=$state(''),tel=$state(''),wa=$state(''),cargo=$state(''),slug=$state('');
  let tipo=$state('hospital-privado'),user=$state(''),pass=$state('');
  let loading=$state(false),err=$state(''),code=$state(''),emailSent=$state(''),checking=$state(false);
  let result = $state<SignupResponse|null>(null);
  let copied = $state(false);
  try {
    const q = new URLSearchParams(location.search);
    const qp = q.get('plan'); if (qp && PLANES.some(p=>p.slug===qp)) plan=qp as PlanSlug;
    const qt = q.get('tipo');
    if (qt==='clinica-medica' || qt?.startsWith('clinica-')) location.replace('https://clinica-privada.com/registro'+location.search);
    else if (qt==='hospital-privado') { step='datos'; }
  } catch {}
  const embed = $derived(typeof location!=='undefined' && new URLSearchParams(location.search).get('embed')==='1');
  function pick(p:PlanSlug){plan=p;tipo='hospital-privado';step='datos';}
  const curPlan = ()=>PLANES.find(p=>p.slug===plan)!;
  const ftrial = ()=>{if(!result)return'';try{return new Date(result.trialEndsAt).toLocaleDateString('es-GT',{day:'numeric',month:'long',year:'numeric'})}catch{return result.trialEndsAt}};
  async function submit(e:SubmitEvent){
    e.preventDefault();err='';loading=true;
    try{await signup({nombre:nombre.trim(),email:email.trim(),telefono:tel.trim(),plan,tipoOrganizacion:tipo as any,slugSugerido:slug.trim()||undefined,cargo:cargo.trim()||undefined,whatsapp:wa.trim()||tel.trim(),usuario:user.trim(),password:pass});emailSent=email.trim();step='verificar';}
    catch(ex:any){err=ex instanceof SignupError?mensajeError(ex.code):ex?.message??'Error';}
    finally{loading=false;}
  }
  async function verify(e:SubmitEvent){
    e.preventDefault();err='';checking=true;
    try{const r=await verifyEmail(emailSent,code.trim());result=r;step='exito';      if(r.usuarioAdmin)try{sessionStorage.setItem(CK,JSON.stringify({usuario:r.usuarioAdmin,password:pass}))}catch{}if(embed&&window!==window.parent)window.parent.postMessage({type:'toscana:signup:complete',plan:r.plan.slug,tenantId:r.tenant.tenantId},'*');}
    catch(ex:any){err=ex instanceof SignupError?mensajeError(ex.code):ex?.message??'Error';}
    finally{checking=false;}
  }
  async function copy(t:string){try{await navigator.clipboard.writeText(t);copied=true;setTimeout(()=>copied=false,1800)}catch{prompt('Copiar:',t)}}
  async function enter(){if(result?.usuarioAdmin)try{await login(undefined,result.usuarioAdmin,pass)}catch{}location.href='/'}
  onMount(()=>{document.documentElement.setAttribute('data-theme','light')});
</script>

<div class="root">
  <header class="topbar">
    <a class="logo" href="/" rel="noopener">
      <img src="https://www.toscanasystems.com/assets/img/logo.png" alt="" />
      <span>Toscana Hospitales</span>
    </a>
    {#if !embed}
    <div class="topbar-actions">
      <a class="clinica-link" href="https://clinica-privada.com/registro" title="Registro para clínicas">¿Buscas clínicas?</a>
      <a class="login-link" href="/login">Iniciar sesión</a>
    </div>
    {/if}
  </header>

  <main class="main">
    {#if step === 'plan'}
      <section class="showcase">
        <div class="showcase-hero">
          <span class="chip">1 mes gratis</span>
          <h1>Elija el plan ideal para su hospital</h1>
          <p class="hero-sub">Comience hoy. Sin compromiso. Cancele cuando quiera.</p>
        </div>
        <div class="showcase-cards">
          {#each PLANES as p (p.slug)}
          <button class="scard" class:popular={p.destacado} onclick={()=>pick(p.slug)} type="button">
            {#if p.destacado}<span class="popular-badge">Más popular</span>{/if}
            <div class="scard-top">
              <span class="scard-name">{p.nombre}</span>
              <div class="scard-price">
                <strong>Q{p.precio.toLocaleString('es-GT')}</strong>
                <span class="scard-period">/mes</span>
              </div>
            </div>
            <p class="scard-desc">{p.resumen}</p>
            <ul class="scard-features">
              {#each p.modulos as m}
              <li>{m}</li>
              {/each}
            </ul>
            <span class="scard-cta">Comenzar</span>
          </button>
          {/each}
        </div>
        <div class="showcase-trust">
          <span>SSL seguro</span>
          <span>Cancele cuando quiera</span>
        </div>
      </section>

    {:else if step === 'datos'}
      <section class="form-step">
        <button class="step-back" onclick={()=>step='plan'} type="button">← Cambiar plan</button>
        <div class="plan-summary">
          <span class="summary-label">Plan seleccionado</span>
          <strong>{curPlan().nombre}</strong>
          <span class="summary-price">Q{curPlan().precio.toLocaleString('es-GT')} /mes</span>
        </div>
        <div class="form-box">
          <h2>Datos del titular</h2>
          <p class="form-desc">Complete la información del responsable de la cuenta.</p>
          <form onsubmit={submit}>
            <div class="field">
              <label for="f-nombre">Nombre comercial *</label>
              <input id="f-nombre" bind:value={nombre} required maxlength="80" placeholder="Clínica San Rafael" />
            </div>
            <div class="field-row">
              <div class="field">
                <label for="f-email">Email *</label>
                <input id="f-email" bind:value={email} type="email" required autocomplete="email" placeholder="doctor@miclinica.gt" />
              </div>
              <div class="field">
                <label for="f-tel">Teléfono *</label>
                <input id="f-tel" bind:value={tel} type="tel" required autocomplete="tel" placeholder="+502 5555-1234" />
              </div>
            </div>
            <div class="field-row">
              <div class="field">
                <label for="f-wa">WhatsApp</label>
                <input id="f-wa" bind:value={wa} type="tel" autocomplete="tel" placeholder="+502 5555-1234" />
                <span class="field-hint">Para recordatorios de citas.</span>
              </div>
              <div class="field">
                <label for="f-cargo">Cargo</label>
                <input id="f-cargo" bind:value={cargo} maxlength="60" placeholder="Director Médico" />
              </div>
            </div>
            <div class="field">
              <label for="f-tipo">Tipo de organización *</label>
              <select id="f-tipo" bind:value={tipo} required>
                <option value="hospital-privado">Hospital privado</option>
              </select>
            </div>
            <div class="field">
              <label for="f-sub">Subdominio</label>
              <input id="f-sub" bind:value={slug} maxlength="40" placeholder="Se genera automáticamente" pattern="^[a-zA-Z0-9\- ]*$" />
              <span class="field-hint">Opcional. Lo generamos del nombre.</span>
            </div>
            <div class="field">
              <label for="f-user">Usuario *</label>
              <div class="input-group">
                <input id="f-user" bind:value={user} type="text" required maxlength="60" placeholder="tucuenta" pattern="^[a-z0-9._\-]+$" autocomplete="username" />
                <span class="input-suffix">@toscanasystems.com</span>
              </div>
              <span class="field-hint">Minúsculas, números, punto y guion.</span>
            </div>
            <div class="field">
              <label for="f-pass">Contraseña *</label>
              <input id="f-pass" bind:value={pass} type="password" required minlength="6" placeholder="Mínimo 6 caracteres" autocomplete="new-password" />
            </div>
            <button type="submit" disabled={loading} class="btn-submit">{loading ? 'Creando…' : 'Continuar'}</button>
            {#if err}<p class="form-err">{err}</p>{/if}
            <p class="form-note">Activación inmediata al verificar su email.</p>
          </form>
        </div>
      </section>

    {:else if step === 'verificar'}
      <section class="form-step">
        <button class="step-back" onclick={()=>step='datos'} type="button">← Editar datos</button>
        <div class="plan-summary">
          <span class="summary-label">Plan seleccionado</span>
          <strong>{curPlan().nombre}</strong>
          <span class="summary-price">Q{curPlan().precio.toLocaleString('es-GT')} /mes</span>
        </div>
        <div class="form-box">
          <h2>Verifique su email</h2>
          <p class="form-desc">Ingrese el código de 6 dígitos enviado a <strong>{emailSent}</strong>.</p>
          <form onsubmit={verify}>
            <div class="field">
              <label for="f-code">Código de verificación</label>
              <input id="f-code" bind:value={code} type="text" inputmode="numeric" required maxlength="6" minlength="6" placeholder="000000" class="code-input" />
            </div>
            <button type="submit" disabled={checking || code.trim().length !== 6} class="btn-submit">{checking ? 'Verificando…' : 'Verificar'}</button>
            {#if err}<p class="form-err">{err}</p>{/if}
            <p class="form-note">El código vence en 10 minutos. <button type="button" class="link-btn" onclick={()=>{step='datos';err=''}}>Reenviar código</button></p>
          </form>
        </div>
      </section>

    {:else if step === 'exito' && result}
      <section class="success-step">
        <div class="success-icon">✓</div>
        <h1>¡Todo listo!</h1>
        <p class="success-lead">1 mes gratis de <strong>{result.plan.nombre}</strong> hasta el <strong>{ftrial()}</strong>.</p>
        <div class="success-details">
          <div class="detail-row">
            <span>ID</span>
            <code>{result.tenant.tenantId}</code>
          </div>
          {#if result.usuarioAdmin}
          <div class="detail-row">
            <span>Usuario</span>
            <div class="detail-copy">
              <code>{result.usuarioAdmin}</code>
              <button class="copy-btn" onclick={()=>copy(result!.usuarioAdmin)}>{copied ? '✓ Copiado' : 'Copiar'}</button>
            </div>
          </div>
          {/if}
          <div class="detail-row">
            <span>Acceso</span>
            <a href={result.loginUrl} target="_blank" rel="noopener">{result.loginUrl}</a>
          </div>
        </div>
        <button class="btn-submit" onclick={enter}>Ingresar →</button>
      </section>
    {/if}
  </main>

  {#if !embed && step === 'plan'}
  <footer class="footbar">© {new Date().getFullYear()} Toscana Systems, S.A. · <a href="https://www.toscanasystems.com">toscanasystems.com</a></footer>
  {/if}
</div>

<style>
  :global(body) {
    margin: 0;
    background: #f8fafc;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    color: #1e293b;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  /* ─── Topbar ─── */
  .topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 32px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
    z-index: 10;
  }
  .logo,
  .logo:visited,
  .logo:hover {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #16a34a;
    font-weight: 700;
    font-size: 16px;
  }
  .logo span { color: #16a34a; }
  .logo img { height: 32px; width: auto; }
  .login-link {
    color: #16a34a;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid rgba(15, 118, 110, 0.2);
    background: #fff;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }
  .topbar-actions { display: flex; align-items: center; gap: 0.6rem; }
  .clinica-link {
    color: #64748b;
    text-decoration: none;
    font-size: 12px;
    font-weight: 500;
    transition: color 0.15s;
  }
  .clinica-link:hover { color: #16a34a; }
  .login-link:hover {
    background: #16a34a;
    color: #fff;
    border-color: #16a34a;
  }

  /* ─── Main ─── */
  .main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 32px;
  }

  /* ─── Showcase (step plan) ─── */
  .showcase {
    width: 100%;
    max-width: 1060px;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
  .showcase-hero {
    text-align: center;
  }
  .chip {
    display: inline-block;
    padding: 6px 16px;
    border-radius: 20px;
    background: #ecfdf5;
    color: #16a34a;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  h1 {
    font-size: 36px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 8px;
    letter-spacing: -0.04em;
    line-height: 1.15;
  }
  .hero-sub {
    font-size: 16px;
    color: #64748b;
    margin: 0;
  }

  .showcase-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: stretch;
  }
  @media (max-width: 860px) {
    .showcase-cards {
      grid-template-columns: 1fr;
      max-width: 400px;
      margin: 0 auto;
    }
    h1 { font-size: 28px; }
  }

  .scard {
    position: relative;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 16px;
    padding: 32px 28px;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    box-shadow:
      0 1px 2px rgba(0, 0, 0, 0.03),
      0 4px 12px rgba(0, 0, 0, 0.03);
    outline: none;
  }
  .scard:hover {
    transform: translateY(-3px);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.04),
      0 12px 28px rgba(0, 0, 0, 0.06);
    border-color: rgba(15, 118, 110, 0.15);
  }
  .scard.popular {
    border: 2px solid #16a34a;
    box-shadow:
      0 2px 4px rgba(15, 118, 110, 0.06),
      0 12px 32px rgba(15, 118, 110, 0.1);
  }
  .scard.popular:hover {
    border-color: #22c55e;
    box-shadow:
      0 4px 8px rgba(15, 118, 110, 0.08),
      0 16px 40px rgba(15, 118, 110, 0.14);
  }

  .popular-badge {
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    background: #16a34a;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 5px 20px;
    border-radius: 0 0 8px 8px;
    white-space: nowrap;
  }

  .scard-top {
    margin-bottom: 16px;
  }
  .scard-name {
    display: block;
    font-size: 19px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
  }
  .scard-price {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }
  .scard-price strong {
    font-size: 38px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.03em;
    line-height: 1;
  }
  .scard-price .scard-period {
    font-size: 14px;
    color: #94a3b8;
    font-weight: 500;
  }

  .scard-desc {
    font-size: 13px;
    color: #64748b;
    line-height: 1.6;
    margin: 0 0 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  .scard-features {
    list-style: none;
    margin: 0 0 24px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .scard-features li {
    position: relative;
    padding-left: 24px;
    font-size: 13px;
    color: #334155;
    line-height: 1.45;
  }
  .scard-features li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ecfdf5;
    border: 1px solid rgba(15, 118, 110, 0.2);
  }
  .scard-features li::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 6px;
    width: 8px;
    height: 5px;
    border-left: 2px solid #16a34a;
    border-bottom: 2px solid #16a34a;
    transform: rotate(-45deg);
  }

  .scard-cta {
    display: block;
    margin-top: auto;
    padding: 12px;
    text-align: center;
    border-radius: 10px;
    background: #1e293b;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: background 0.15s, transform 0.15s;
  }
  .scard:hover .scard-cta {
    background: #0f172a;
  }
  .scard.popular .scard-cta {
    background: linear-gradient(135deg, #16a34a, #22c55e);
  }
  .scard.popular:hover .scard-cta {
    background: linear-gradient(135deg, #15803d, #16a34a);
  }

  .showcase-trust {
    display: flex;
    justify-content: center;
    gap: 32px;
    font-size: 13px;
    color: #94a3b8;
  }
  .showcase-trust span {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
  }
  .showcase-trust span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #22c55e;
  }

  /* ─── Form steps (datos / verificar) ─── */
  .form-step {
    width: 100%;
    max-width: 560px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .step-back {
    font-size: 13px;
    font-weight: 600;
    color: #16a34a;
    text-decoration: none;
    align-self: flex-start;
    background: none;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    padding: 0;
  }
  .step-back:hover { color: #22c55e; }

  .plan-summary {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .summary-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-right: 8px;
  }
  .plan-summary strong {
    font-size: 16px;
    color: #0f172a;
    font-weight: 700;
  }
  .summary-price {
    font-size: 16px;
    font-weight: 700;
    color: #16a34a;
    margin-left: auto;
  }

  .form-box {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    padding: 40px;
  }
  @media (max-width: 500px) {
    .form-box { padding: 24px 20px; }
  }
  .form-box h2 {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px;
    letter-spacing: -0.02em;
  }
  .form-desc {
    font-size: 14px;
    color: #64748b;
    margin: 0 0 32px;
  }
  .form-desc strong { color: #0f172a; font-weight: 600; }

  .field {
    margin-bottom: 20px;
  }
  .field label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 6px;
  }
  .field input,
  .field select {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 14px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font: inherit;
    font-size: 14px;
    background: #fff;
    color: #1e293b;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .field input::placeholder { color: #cbd5e1; }
  .field input:focus,
  .field select:focus {
    outline: none;
    border-color: #16a34a;
    box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.1);
  }
  .field-hint {
    display: block;
    font-size: 12px;
    color: #94a3b8;
    margin-top: 5px;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  @media (max-width: 480px) {
    .field-row { grid-template-columns: 1fr; }
  }

  .input-group {
    display: flex;
    align-items: stretch;
  }
  .input-group input {
    flex: 1;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
  .input-suffix {
    display: flex;
    align-items: center;
    padding: 0 12px;
    background: #f1f5f9;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-left: 0;
    border-radius: 0 8px 8px 0;
    font-size: 12px;
    color: #64748b;
    font-weight: 600;
    white-space: nowrap;
  }

  .code-input {
    font-size: 32px !important;
    letter-spacing: 16px !important;
    text-align: center !important;
    font-family: 'JetBrains Mono', 'SF Mono', 'Cascadia Code', monospace !important;
    padding: 16px !important;
  }

  .btn-submit {
    display: block;
    width: 100%;
    padding: 14px;
    border: 0;
    border-radius: 10px;
    background: #1e293b;
    color: #fff;
    font: inherit;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
  }
  .btn-submit:hover:not(:disabled) {
    background: #0f172a;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
  .btn-submit:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .form-err {
    color: #dc2626;
    font-size: 13px;
    margin: 16px 0 0;
    text-align: center;
    background: #fef2f2;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #fecaca;
  }
  .form-note {
    text-align: center;
    color: #94a3b8;
    font-size: 12px;
    margin: 20px 0 0;
  }
  .link-btn {
    background: none;
    border: 0;
    color: #16a34a;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
  }
  .link-btn:hover { color: #22c55e; text-decoration: underline; }

  /* ─── Success step ─── */
  .success-step {
    text-align: center;
    max-width: 440px;
    width: 100%;
  }
  .success-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: #fff;
    font-size: 32px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    box-shadow: 0 8px 24px rgba(15, 118, 110, 0.2);
    animation: pop-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes pop-in {
    0% { transform: scale(0); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
  .success-lead {
    font-size: 16px;
    color: #475569;
    margin: 8px 0 28px;
    line-height: 1.6;
  }
  .success-lead strong { color: #0f172a; font-weight: 700; }

  .success-details {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 14px;
    padding: 20px 24px;
    text-align: left;
    margin-bottom: 28px;
  }
  .detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    gap: 12px;
  }
  .detail-row:last-child { border-bottom: 0; }
  .detail-row > span {
    font-size: 13px;
    color: #94a3b8;
    font-weight: 500;
    flex-shrink: 0;
  }
  .detail-row code,
  .detail-row a {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    word-break: break-all;
    text-align: right;
  }
  .detail-copy {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .detail-copy code {
    background: #f1f5f9;
    padding: 3px 10px;
    border-radius: 6px;
    font-family: 'JetBrains Mono', 'SF Mono', 'Cascadia Code', monospace;
    font-size: 13px;
    color: #16a34a;
  }
  .copy-btn {
    padding: 4px 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #fff;
    font: inherit;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    color: #16a34a;
    white-space: nowrap;
    transition: background 0.15s;
  }
  .copy-btn:hover { background: #f0fdfa; }

  /* ─── Footbar ─── */
  .footbar {
    text-align: center;
    padding: 16px;
    font-size: 12px;
    color: #94a3b8;
    background: rgba(255, 255, 255, 0.6);
    border-top: 1px solid rgba(0, 0, 0, 0.04);
    flex-shrink: 0;
  }
  .footbar a,
  .footbar a:visited,
  .footbar a:hover {
    color: #16a34a;
    font-weight: 600;
    text-decoration: none;
  }
</style>
